(function () {
  function setupComparisonLanes(root) {
var SECTION_ID = root.id.slice(3);
    var registry = window.__vanemarLaneSections = window.__vanemarLaneSections || {};
    if (registry[SECTION_ID]) {
      registry[SECTION_ID].init();
      return;
    }

    var teardown = null;

    function init() {
      if (teardown) teardown();
      var root = document.getElementById('vl-' + SECTION_ID);
      if (!root || root.getAttribute('data-vl-ready') === 'true') return;

      var track = root.querySelector('[data-mobile-track]');
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
      var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-step-trigger]'));

      var laneStacks = Array.prototype.slice.call(root.querySelectorAll('[data-lane-stack]'));
      var desktopLaneItems = Array.prototype.slice.call(root.querySelectorAll('.vl-side-text'));
      var mobileLaneItems = Array.prototype.slice.call(root.querySelectorAll('.vl-mobile-lane'));
      var desktopPanel = root.querySelector('.vl-panel');
      var mediaItems = Array.prototype.slice.call(root.querySelectorAll('[data-media-index]'));
      var currentLabel = root.querySelector('[data-mobile-current]');
      
      if (!steps.length || !track) return;
      root.setAttribute('data-vl-ready', 'true');

      var desktopQuery = window.matchMedia('(min-width: 1024px)');
      var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      var reduceMotion = motionQuery.matches;
      var current = -1;
      var lastViewportWidth = window.innerWidth || document.documentElement.clientWidth;
      var headerObserver = null;
      var bandObserver = null;
      var videoObserver = null;
      var sectionObserver = null;
      var sectionNearby = !('IntersectionObserver' in window);
      var chapter = -1;
      var cleanup = [];

      function listen(target, type, handler, options) {
        if (!target || !target.addEventListener) return;
        target.addEventListener(type, handler, options);
        cleanup.push(function () { target.removeEventListener(type, handler, options); });
      }

      function clamp(value, min, max) { return Math.min(Math.max(value, min), max); }

      function padIndex(index) {
        var value = String(index + 1);
        return value.length < 2 ? '0' + value : value;
      }

      function syncResponsiveAccessibility() {
        var isDesktop = desktopQuery.matches;
        if (desktopPanel) {
          desktopPanel.setAttribute('aria-hidden', isDesktop ? 'false' : 'true');
          if ('inert' in desktopPanel) desktopPanel.inert = !isDesktop;
        }
        mobileLaneItems.forEach(function (item) {
          item.setAttribute('aria-hidden', isDesktop ? 'true' : 'false');
        });
        desktopLaneItems.forEach(function (item) {
          item.setAttribute('aria-hidden', 'true');
        });
      }

      function apply(i) {
        i = clamp(i, 0, steps.length - 1);
        if (i === current) return;
        current = i;
        steps.forEach(function (step, idx) {
          var isActive = idx === i;
          step.classList.toggle('is-active', isActive);
          var trigger = step.querySelector('[data-step-trigger]');
          if (trigger) {
            if (isActive && desktopQuery.matches) trigger.setAttribute('aria-current', 'step');
            else trigger.removeAttribute('aria-current');
          }
        });
        mediaItems.forEach(function (item, idx) {
          item.classList.toggle('is-active', idx === i);
        });
        syncPanelVideos(i);
        laneStacks.forEach(function (stack) {
          var items = stack.querySelectorAll('[data-lane-item]');
          for (var idx = 0; idx < items.length; idx += 1) {
            var isActive = idx === i;
            items[idx].classList.toggle('is-active', isActive);
            items[idx].setAttribute('aria-hidden', desktopQuery.matches && isActive ? 'false' : 'true');
          }
        });
      }

      function getHeaderHeight() {
        var header = document.getElementById('site-header') || document.querySelector('header');
        if (!header) return 0;
        var styles = window.getComputedStyle(header);
        if (styles.display === 'none' || styles.visibility === 'hidden') return 0;
        if (styles.position !== 'fixed' && styles.position !== 'sticky') return 0;
        return Math.max(0, Math.round(header.getBoundingClientRect().height));
      }

      
      function measure() {
        syncResponsiveAccessibility();
        
        root.style.setProperty('--vl-navbar', getHeaderHeight() + 'px');
        if (desktopQuery.matches) {
          triggers.forEach(function (trigger) {
            trigger.setAttribute('role', 'button');
            trigger.setAttribute('tabindex', '0');
            trigger.setAttribute('aria-label', trigger.getAttribute('data-trigger-label') || '');
          });
          stopChapters();
          stopVideos();
          
          steps.forEach(function (step) { step.classList.remove('is-cur'); });
          chapter = -1;
          
          var selected = current < 0 ? 0 : current;
          current = -1;
          apply(selected);
        } else {
          triggers.forEach(function (trigger) {
            trigger.removeAttribute('role');
            trigger.removeAttribute('tabindex');
            trigger.removeAttribute('aria-label');
            trigger.removeAttribute('aria-current');
          });
          
          steps.forEach(function (step) { step.classList.remove('is-active'); });
          chapter = -1;
          setChapter(0);
          startChapters();
          startVideos();
        }
      }

      
      function setChapter(i) {
        i = clamp(i, 0, steps.length - 1);
        if (i === chapter) return;
        chapter = i;
        var step = steps[i];
        root.style.setProperty('--vl-mobile-progress', ((i + 1) / steps.length).toFixed(4));
        root.style.setProperty('--vl-cur-acc', step.getAttribute('data-acc') || '');
        if (currentLabel) currentLabel.textContent = padIndex(i);
        
        steps.forEach(function (other, idx) {
          other.classList.toggle('is-cur', idx === i);
        });
      }

      
      function startChapters() {
        if (bandObserver || !('IntersectionObserver' in window)) return;
        bandObserver = new IntersectionObserver(function (entries) {
          var best = null;
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            if (!best || entry.target.getBoundingClientRect().top < best.getBoundingClientRect().top) {
              best = entry.target;
            }
          });
          if (best) setChapter(Number(best.getAttribute('data-index')) || 0);
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
        steps.forEach(function (step) { bandObserver.observe(step); });
      }

      function stopChapters() {
        if (!bandObserver) return;
        bandObserver.disconnect();
        bandObserver = null;
      }

      
      
      function allowsVideo() {
        return window.VMConnection ? window.VMConnection.allowsVideo() : true;
      }

      function playVideo(video) {
        if (!video || !allowsVideo()) return null;
        return window.VMConnection && window.VMConnection.playVideo
          ? window.VMConnection.playVideo(video)
          : video.play();
      }

      function startVideos() {
        var videos = Array.prototype.slice.call(root.querySelectorAll('.vl-mobile-media video'));
        if (!videos.length) return;
        if (!allowsVideo()) {
          videos.forEach(function (video) { video.pause(); });
          return;
        }
        if (reduceMotion) {
          videos.forEach(function (video) {
            video.pause();
            video.controls = true;
            video.removeAttribute('autoplay');
          });
          return;
        }
        videos.forEach(function (video) { video.controls = false; });
        if (!('IntersectionObserver' in window)) {
          videos.forEach(function (video) {
            video.pause();
            video.controls = true;
          });
          return;
        }
        if (videoObserver) return;
        videoObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              var playing = playVideo(video);
              if (playing && playing.catch) playing.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { rootMargin: '200px 0px', threshold: 0 });
        videos.forEach(function (video) { videoObserver.observe(video); });
      }

      function stopVideos() {
        if (!videoObserver) return;
        videoObserver.disconnect();
        videoObserver = null;
      }

      
      function syncPanelVideos(i) {
        if (!mediaItems.length) return;
        mediaItems.forEach(function (item, idx) {
          var video = item.querySelector('video');
          if (!video) return;
          if (idx === i && desktopQuery.matches && !reduceMotion && sectionNearby && allowsVideo()) {
            var playing = playVideo(video);
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            video.pause();
          }
        });
      }

      
      function focusStep(i) {
        i = clamp(i, 0, triggers.length - 1);
        apply(i);
        if (triggers[i]) triggers[i].focus();
      }

      triggers.forEach(function (trigger, idx) {
        listen(trigger, 'click', function () {
          if (desktopQuery.matches) apply(idx);
        });
        listen(trigger, 'keydown', function (event) {
          if (!desktopQuery.matches) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            apply(idx);
          } else if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            event.preventDefault();
            focusStep(idx + 1);
          } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
            event.preventDefault();
            focusStep(idx - 1);
          } else if (event.key === 'Home') {
            event.preventDefault();
            focusStep(0);
          } else if (event.key === 'End') {
            event.preventDefault();
            focusStep(triggers.length - 1);
          }
        });
      });

      function onResize() {
        var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        if (!desktopQuery.matches && Math.abs(viewportWidth - lastViewportWidth) < 1) return;
        lastViewportWidth = viewportWidth;
        measure();
      }

      function onBreakpointChange() {
        lastViewportWidth = window.innerWidth || document.documentElement.clientWidth;
        measure();
        if (!desktopQuery.matches) syncPanelVideos(-1);
      }

      function onMotionChange(event) {
        reduceMotion = event.matches;
        if (!desktopQuery.matches) {
          stopVideos();
          startVideos();
        }
      }

      
      if (window.VMConnection) {
        cleanup.push(window.VMConnection.subscribe(function () {
          if (desktopQuery.matches) syncPanelVideos(current);
          else { stopVideos(); startVideos(); }
        }));
      }

      function onBlockSelect(event) {
        var selected = event.target && event.target.closest ? event.target.closest('[data-step]') : null;
        if (!selected || !root.contains(selected)) return;
        var index = Number(selected.getAttribute('data-index')) || 0;
        if (desktopQuery.matches) apply(index);
        else selected.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      teardown = function () {
        cleanup.forEach(function (remove) { remove(); });
        cleanup = [];
        if (headerObserver) headerObserver.disconnect();
        if (sectionObserver) sectionObserver.disconnect();
        stopChapters();
        stopVideos();
        root.removeAttribute('data-vl-ready');
        teardown = null;
      };

      listen(window, 'resize', onResize, { passive: true });
      listen(window, 'load', onResize);
      if (window.visualViewport) listen(window.visualViewport, 'resize', onResize, { passive: true });
      if (desktopQuery.addEventListener) listen(desktopQuery, 'change', onBreakpointChange);
      else if (desktopQuery.addListener) {
        desktopQuery.addListener(onBreakpointChange);
        cleanup.push(function () { desktopQuery.removeListener(onBreakpointChange); });
      }
      if (motionQuery.addEventListener) listen(motionQuery, 'change', onMotionChange);
      else if (motionQuery.addListener) {
        motionQuery.addListener(onMotionChange);
        cleanup.push(function () { motionQuery.removeListener(onMotionChange); });
      }
      listen(document, 'shopify:block:select', onBlockSelect);
      var observedHeader = document.getElementById('site-header') || document.querySelector('header');
      if (observedHeader && 'ResizeObserver' in window) {
        headerObserver = new ResizeObserver(onResize);
        headerObserver.observe(observedHeader);
      }
      if ('IntersectionObserver' in window) {
        sectionObserver = new IntersectionObserver(function (entries) {
          sectionNearby = !!(entries[0] && entries[0].isIntersecting);
          if (sectionNearby) {
            syncPanelVideos(current < 0 ? 0 : current);
          } else {
            root.querySelectorAll('video').forEach(function (video) { video.pause(); });
          }
        }, { rootMargin: '75% 0px', threshold: 0 });
        sectionObserver.observe(root);
      }

      measure();
      apply(current < 0 ? 0 : current);
    }

    registry[SECTION_ID] = {
      init: init,
      destroy: function () { if (teardown) teardown(); }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  }

  function boot(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-comparison-lanes]')) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-comparison-lanes]')));
    }
    roots.forEach(setupComparisonLanes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
